import * as React from 'react'
import dynamic from 'next/dynamic'

import { Button } from '@thg-commerce/gravity-elements'
import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'

export const Basket = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/BasketIcon'),
  { loading: () => <BasketIconSkeleton />, ssr: true },
)

export const Container = styled.div<{ enableRecs?: boolean }>`
  background-color: ${(props) => props.theme.colors.palette.greys.white};

  ${(props) =>
    props.enableRecs
      ? `padding: 0; margin-bottom: ${spacing(5)};`
      : `padding: ${spacing(1)} ${spacing(2)} ${spacing(1)} ${spacing(2)}`};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${(props) => (props.enableRecs ? '0' : `${spacing(4)} 0`)};
  }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing(7)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(8)};
  }
`

export const Title = styled.p`
  ${Text('large1', 'alternate')}
  margin: ${spacing(2)} auto ${spacing(1)} auto;
  text-align: center;
`

export const Subtitle = styled.p`
  margin: 0 auto ${spacing(2)} auto;
  text-align: center;
`

export const BasketIcon = styled(Basket)`
  width: 64px;
  height: 64px;
  margin: 0 auto;
`

export const BasketIconSkeleton = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto;
`

export const ContinueShoppingLink = styled(Button)`
  margin: 0 auto;
`
